export const mappedWeekday = (weekDayFromMoment) => {
  return weekDayFromMoment.locale("en").format("ddd").toLowerCase();
}